import { Injectable } from '@angular/core';
import { ProductNames } from '@xbs/xbs-enums';
import * as xbsPlatformModule from '@xbs/xbs-platform-module';
import { AppConfig } from './app-config';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {
  platformModule;

  constructor(protected _config: AppConfig) {}

  public getPlatformModule() {
    if (!this.platformModule) {
      this.platformModule = xbsPlatformModule.getInstance(ProductNames.ByName.Tpiq.Uuid, this._config.getEnvironmentShort());
    }
    return this.platformModule;
  }
}
